"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWindowLocale = exports.formatLocale = void 0;
exports.formatLocale = (language, countryCode) => {
    const country = countryCode ? `-${countryCode}` : '';
    return `${language}${country}`;
};
exports.getWindowLocale = () => {
    // @ts-ignore - global hl
    const language = window.hl || 'en';
    // @ts-ignore - global co
    const countryCode = window.co || '';
    return exports.formatLocale(language, countryCode);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xpYi9jb21tb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxZQUFZLEdBQUcsQ0FBQyxRQUFnQixFQUFFLFdBQW9CLEVBQUUsRUFBRTtJQUNuRSxNQUFNLE9BQU8sR0FBRyxXQUFXLENBQUMsQ0FBQyxDQUFDLElBQUksV0FBVyxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQztJQUVyRCxPQUFPLEdBQUcsUUFBUSxHQUFHLE9BQU8sRUFBRSxDQUFDO0FBQ25DLENBQUMsQ0FBQTtBQUVZLFFBQUEsZUFBZSxHQUFHLEdBQVcsRUFBRTtJQUN4Qyx5QkFBeUI7SUFDekIsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLEVBQUUsSUFBSSxJQUFJLENBQUM7SUFDbkMseUJBQXlCO0lBQ3pCLE1BQU0sV0FBVyxHQUFHLE1BQU0sQ0FBQyxFQUFFLElBQUksRUFBRSxDQUFDO0lBRXBDLE9BQU8sb0JBQVksQ0FBQyxRQUFRLEVBQUUsV0FBVyxDQUFDLENBQUM7QUFDL0MsQ0FBQyxDQUFDIn0=